import { createNullableContext } from '~/common/contexts/nullableContext';
import { FeaturesContextType } from './types/FeaturesContextType';

export const FeaturesContext = createNullableContext<FeaturesContextType>();
